export const TNL_UPDATE_STATE = "TNL_UPDATE_STATE"